var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex mt-32 flex-wrap"},[_c('div',{staticClass:"w-full xl:w-8/12 mb-12 xl:mb-0 px-4"},[_vm._v(" hi there ")]),_c('div',{staticClass:"w-full xl:w-4/12 px-4"},[_vm._v(" How are you ")])])
}]

export { render, staticRenderFns }